import React from 'react';
import Loading from 'Components/Loading';
import { COACHING_IFRAME_ID } from '../constants';

// Presentational iframe for the Coaching app. `key={src}` forces a remount when the token changes.
// The frame stays mounted while loading (so the request runs) but is hidden behind a spinner.
// `frameRef` gives the parent the iframe element (used to postMessage into it).
const CoachingFrame = ({ src, title, isLoaded, onLoad, frameRef }) => (
  <div className="coach-sso-view__body">
    {!isLoaded && <Loading full />}
    <iframe
      key={src}
      ref={frameRef}
      id={COACHING_IFRAME_ID}
      className="coach-sso-view__frame"
      title={title}
      src={src}
      width="100%"
      height="100%"
      allow="clipboard-write; fullscreen"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ visibility: isLoaded ? 'visible' : 'hidden' }}
      onLoad={onLoad}
    />
  </div>
);

export default CoachingFrame;
